import React, {
  useContext,
  useState
} from "react";
import InvoiceTemplate from "../components/InvoiceTemplate";
import { ProductContext } from "../context/ProductContext";

import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";
import { useEffect } from "react";
import logo from "../assets/Alogo.png";
import { getShopId } from "../utils/shop";

import websiteQR from "../assets/website-qr.png";

import {
  FaCalendarAlt,
  FaDownload,
  FaSearch,
  FaFilter,
  FaPrint,
  FaReceipt,
  FaMoneyBillWave,
  FaShoppingBag,
  FaChartPie,
  FaEye
} from "react-icons/fa";

import "../styles/Sales.css";

function Sales() {

  const [selectedInvoice, setSelectedInvoice] = useState(null);

  const [salesHistory, setSalesHistory] = useState([]);

  useEffect(() => {

  const fetchInvoices = async () => {

    try {

      const shopId = getShopId();

      const querySnapshot = await getDocs(
        collection(
          db,
          "shops",
          shopId,
          "invoices"
        )
      );

      const invoices = querySnapshot.docs.map(
        (doc) => ({
          id: doc.id,
          ...doc.data(),
        })
      );

      invoices.sort((a, b) => {
        const aTime =
          a.createdAt?.seconds || 0;

        const bTime =
          b.createdAt?.seconds || 0;

        return bTime - aTime;
      });

      setSalesHistory(invoices);

    } catch (error) {

      console.error(
        "Error fetching invoices:",
        error
      );

    }

  };

  fetchInvoices();

}, []);

  const totalRevenue = salesHistory.reduce(
  (acc, sale) =>
    acc + Number(sale.grandTotal || 0),
  0
);
  const totalGST = totalRevenue * 0.18;

  const averageOrder =
    salesHistory.length > 0
      ? totalRevenue / salesHistory.length
      : 0;

      const [paymentFilter, setPaymentFilter] =
  useState("All");

  const [currentPage, setCurrentPage] =
  useState(1);

const [entriesPerPage,
setEntriesPerPage] =
  useState(10);

const filteredSales =
  salesHistory.filter((sale) => {

    if (paymentFilter === "All")

      
      return true;

      

   
    return (
      (sale.paymentMethod || "Cash")
        .toLowerCase() ===
      paymentFilter.toLowerCase()
    );

  });

  const lastIndex =
  currentPage * entriesPerPage;

const firstIndex =
  lastIndex - entriesPerPage;

const currentSales =
  filteredSales.slice(
    firstIndex,
    lastIndex
  );

const totalPages =
  Math.ceil(
    filteredSales.length /
    entriesPerPage
  );


  
  

  const printInvoice = () => {
  const receipt =
    document.getElementById("printable-receipt");

    const styles = Array.from(
  document.querySelectorAll(
    'style, link[rel="stylesheet"]'
  )
)
  .map((el) => el.outerHTML)
  .join("");

  const printWindow = window.open("", "", "width=400,height=800");

  printWindow.document.write(`
    <html>
      <head>
  <title>Receipt</title>
  ${styles}

        <style>
          body{
            margin:0;
            padding:10px;
            background:white;
          }

          .bill-buttons{
            display:none !important;
          }

          @page{
  size:80mm auto;
  margin:0;
}

body{
  width:80mm;
  margin:0;
  padding:0;
  background:white;
}

.invoice-content{
  width:78mm !important;
  max-width:78mm !important;
  margin:0 auto;
  background:white;
}

          button{
            display:none !important;
          }
        </style>
      </head>

      <body>
        ${receipt.outerHTML}
      </body>
    </html>
  `);

  printWindow.document.close();

  setTimeout(() => {
  printWindow.document.body.style.zoom = "120%";

  printWindow.focus();
  printWindow.print();
  printWindow.close();
}, 500);
};

const billItems = [
  ...(selectedInvoice?.items || []),

  ...(selectedInvoice?.deliveryCharge > 0
    ? [{ name: "Delivery Charges", qty: 1, price: selectedInvoice.deliveryCharge }]
    : []),

  ...(selectedInvoice?.labourCharge > 0
    ? [{ name: "Labour Charges", qty: 1, price: selectedInvoice.labourCharge }]
    : []),

  ...(selectedInvoice?.packingCharge > 0
    ? [{ name: "Packing Charges", qty: 1, price: selectedInvoice.packingCharge }]
    : []),

  ...(selectedInvoice?.plantCharge > 0
    ? [{ name: "Plants Charges", qty: 1, price: selectedInvoice.plantCharge }]
    : []),

  ...(selectedInvoice?.cardCharge > 0
    ? [{ name: "Card Charges", qty: 1, price: selectedInvoice.cardCharge }]
    : []),

  ...(selectedInvoice?.unloadingCharge > 0
    ? [{ name: "Unloading Charges", qty: 1, price: selectedInvoice.unloadingCharge }]
    : [])
];

const totalSavings = (selectedInvoice?.items || []).reduce(
  (sum, item) => {
    const mrp = Number(
      String(item.mrpPrice || 0).replace(/[^\d.]/g, "")
    );

    const rate = Number(
      String(item.price || 0).replace(/[^\d.]/g, "")
    );

    const qty = Number(item.qty || 1);

    return sum + Math.max(0, (mrp - rate) * qty);
  },
  0
);

  return (
    <div className="sales-page">

      {/* HEADER */}

      <div className="sales-topbar">

        <div>

          <h1>Sales History</h1>

          <p>
            Track and manage every
            transaction with precision.
          </p>

        </div>

        <div className="sales-actions">

          <button className="month-btn">

            <FaCalendarAlt />

            This Month

          </button>

          <button className="export-btn">

            <FaDownload />

            Export Report

          </button>

        </div>

      </div>

      {/* CARDS */}

      <div className="sales-cards">

        <div className="sales-card">

          <div className="card-icon blue">
            <FaMoneyBillWave />
          </div>

          <span>Total Revenue</span>

          <h2>
            ₹
            {totalRevenue.toLocaleString()}
          </h2>

        </div>

        <div className="sales-card">

          <div className="card-icon purple">
            <FaReceipt />
          </div>

          <span>Total GST Collected</span>

          <h2>
            ₹
            {totalGST.toLocaleString()}
          </h2>

        </div>

        <div className="sales-card">

          <div className="card-icon orange">
            <FaShoppingBag />
          </div>

          <span>Transaction Count</span>

          <h2>{salesHistory.length}</h2>

        </div>

        <div className="sales-card">

          <div className="card-icon light">
            <FaChartPie />
          </div>

          <span>Average Order Value</span>

          <h2>
            ₹
            {averageOrder.toFixed(2)}
          </h2>

        </div>

      </div>

      {/* TABLE */}

      <div className="sales-table-wrapper">

        {/* FILTERS */}

        <div className="sales-filters">

          <div className="sales-search">

            <FaSearch />

            <input
              type="text"
              placeholder="Search Invoice ID or Customer..."
            />

          </div>

          <select
  value={paymentFilter}

  onChange={(e) =>
    setPaymentFilter(
      e.target.value
    )
  }
>

  <option value="All">
    Payment Status: All
  </option>

  <option value="Cash">
    Cash
  </option>

  <option value="Card">
    Card
  </option>

  <option value="UPI">
    UPI
  </option>

</select>

          <select>
            <option>
              Staff: All Cashiers
            </option>
          </select>

          <button className="filter-btn">
            <FaFilter />
          </button>

        </div>

        {/* TABLE */}

        <table className="sales-table">

          <thead>

            <tr>
              <th>S.No</th>
              <th>Transaction ID</th>
              <th>Date & Time</th>
              <th>Customer</th>
              <th>Payment Method</th>
              <th>Total Amount</th>
              <th>GST Amount</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>

          </thead>

          <tbody>

            {currentSales.map((sale, index) => (

              <tr key={sale.id}>

                <td>
  {firstIndex + index + 1}
</td>

                <td>{sale.invoiceNo}</td>

                <td>
  {sale.createdAt
    ? new Date(
        sale.createdAt.seconds * 1000
      ).toLocaleString()
    : "-"}
</td>

                <td>

                  <div className="customer-cell">

                    <strong>
  {sale.customerName ||
   sale.customer ||
   "Walk-in Customer"}
</strong>

<small>
  {sale.phone ||
   sale.customerPhone ||
   ""}
</small>

                  </div>

                </td>

                <td>
  {sale.paymentMethod || "Cash"}
</td>

                <td>
                  ₹
                  {(sale.grandTotal || 0).toFixed(2)}
                </td>

                <td>
                  ₹
                  {((sale.cgst || 0) + (sale.sgst || 0)).toFixed(2)}
                </td>

                <td className="status-cell">

  <span className="status completed">
    COMPLETED
  </span>

</td>

                <td className="action-cell">

  <div className="action-buttons">

  <FaEye
    style={{
      cursor: "pointer",
      marginRight: "12px"
    }}
    onClick={() => {
  console.log(sale);
  setSelectedInvoice(sale);
}}
  />

  <FaPrint
  style={{ cursor: "pointer" }}
  onClick={() => {
    setSelectedInvoice(sale);
  }}
/>

</div>



                </td>

              </tr>

            ))}

          </tbody>

        </table>

        {/* PAGINATION */}

        <div className="sales-pagination">

          <span>

  Showing
  {firstIndex + 1}
  -

  {
    Math.min(
      lastIndex,
      filteredSales.length
    )
  }

  of

  {
    filteredSales.length
  }

  transactions

</span>

          <div className="pagination-right">

<select
  value={entriesPerPage}

  onChange={(e) => {

    setEntriesPerPage(
      Number(e.target.value)
    );

    setCurrentPage(1);

  }}
>

  <option value={10}>
    10 Entries
  </option>

  <option value={25}>
    25 Entries
  </option>

  <option value={50}>
    50 Entries
  </option>

</select>

<div className="pagination-buttons">
  </div>

  <button
    disabled={currentPage === 1}

    onClick={() =>
      setCurrentPage(
        currentPage - 1
      )
    }
  >
    {"<"}
  </button>

  {[...Array(totalPages)].map(
    (_, index) => (

      <button
        key={index}

        className={
          currentPage ===
          index + 1

            ? "active-page"
            : ""
        }

        onClick={() =>
          setCurrentPage(
            index + 1
          )
        }
      >
        {index + 1}
      </button>

    )
  )}

  <button
    disabled={
      currentPage === totalPages
    }

    onClick={() =>
      setCurrentPage(
        currentPage + 1
      )
    }
  >
    {">"}
  </button>

</div>

        </div>

      </div>

      {/* BOTTOM CARDS */}

      <div className="sales-bottom-grid">

        <div className="bottom-card">

          <h4>Low Stock Alerts</h4>

          <div className="alert-row">

            <span>
              Premium Filter Paper (X-2)
            </span>

            <strong>12% Left</strong>

          </div>

          <div className="progress-bar">

            <div className="progress red"></div>

          </div>

          <div className="alert-row">

            <span>
              Industrial Lubricant 5L
            </span>

            <strong>28% Left</strong>

          </div>

          <div className="progress-bar">

            <div className="progress orange"></div>

          </div>

        </div>

        <div className="bottom-card large-card">

          <div className="performance-header">

            <h4>
              Regional Sales Performance
            </h4>

            <span>•••</span>

          </div>

          <div className="region-row">

            <span>Maharashtra</span>

            <strong>₹ 4.2M</strong>

          </div>

          <div className="region-row">

            <span>Karnataka</span>

            <strong>₹ 2.8M</strong>

          </div>

          <div className="region-row">

            <span>Tamil Nadu</span>

            <strong>₹ 1.9M</strong>

          </div>

        </div>

      </div>
      

      {selectedInvoice && (
  <div className="invoice-modal">

    <InvoiceTemplate
      invoice={selectedInvoice}
      billItems={billItems}
      subtotal={selectedInvoice.subtotal || 0}
      discount={selectedInvoice.discount || 0}
      totalCGST={selectedInvoice.cgst || 0}
      totalSGST={selectedInvoice.sgst || 0}
      grandTotal={selectedInvoice.grandTotal || 0}
      totalSavings={totalSavings}
      onPrint={printInvoice}
      onClose={() =>
        setSelectedInvoice(null)
      }
    />

  </div>
)}


    </div>

    
  );
}

export default Sales;